import { useUser } from "@/components/SupabaseProvider";
import { ComponentPropsWithoutRef, FC, cloneElement } from "react";
import { REVIEW_USER_EMAILS } from "../const/webConst";
import { useConnectAccountPoll } from "../hooks/useConnectAccountPoll";
import { SocialProviderType } from "../types/models";
import { providerTypeToIconLabel } from "./AddSocialProviderAccountButton";
import Button from "./Button";
import { COMING_SOON_PROVIDERS } from "./NotConnectedSocialProviderAccountAvatar";

type SocialProviderEmptyStateProps = {
  provider: SocialProviderType;
  /** When true, button label is only the provider name (e.g. "LinkedIn"). When false, prefix with "Connect " (default). */
  labelProviderOnly?: boolean;
  /** Replaces the plain `authorize(provider)`, e.g. with useConnectAccountPoll's `connect` so the list refreshes once OAuth completes. */
  onConnect?: (provider: SocialProviderType) => void;
} & ComponentPropsWithoutRef<"div">;

const SocialProviderEmptyState: FC<SocialProviderEmptyStateProps> = ({
  provider,
  labelProviderOnly = false,
  onConnect,
  ...rest
}) => {
  const { connect } = useConnectAccountPoll();
  const user = useUser();
  const comingSoonProviders = REVIEW_USER_EMAILS.includes(user?.email ?? "")
    ? []
    : COMING_SOON_PROVIDERS;

  const buttonLabel = labelProviderOnly
    ? providerTypeToIconLabel[provider].label
    : `Connect ${providerTypeToIconLabel[provider].label}`;

  return (
    <div
      {...rest}
      data-tooltip-content={
        comingSoonProviders.includes(provider) ? "Coming soon" : undefined
      }
      data-tooltip-id="global"
    >
      <Button
        variant="secondary"
        disabled={comingSoonProviders.includes(provider)}
        onClick={() =>
          onConnect ? onConnect(provider) : connect(provider)
        }
        className={`w-full`}
      >
        {cloneElement(providerTypeToIconLabel[provider].icon, {
          className: `${providerTypeToIconLabel[provider].icon.props.className} stroke-none`,
        })}
        {buttonLabel}
      </Button>
    </div>
  );
};

export default SocialProviderEmptyState;
